import { render, staticRenderFns } from "./RecordMixins.vue?vue&type=template&id=5dca94db&scoped=true"
import script from "./RecordMixins.vue?vue&type=script&lang=js"
export * from "./RecordMixins.vue?vue&type=script&lang=js"
import style0 from "./RecordMixins.vue?vue&type=style&index=0&id=5dca94db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca94db",
  null
  
)

export default component.exports